<template>
  <div v-if="!ISLOADING" class="container-fluid">
    <div class="row">
      <div class="col-sm-1 d-none d-sm-flex align-items-center">
        <router-link to="/" class="d-none d-sm-block">
          <!-- <img v-if="routerName == 'AboutUs' || routerName == 'packageDetails' || routerName == 'detailsMaintenance'" src="/assets/images/logo-2.png" alt="" class="header-logo" /> -->
          <img :src="(newDesign)? '/assets/images/logo-2.png' : '/assets/images/logo.png'" alt="" class="header-logo" />
        </router-link>
      </div>

      <div class="col-3 col-sm d-flex align-items-center">
        <button @click="menuClick"
          class="navbar-toggler menu-button mx-2"
          id="mobNavBtn"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <!-- begin: Computer screen -->
        <div :class="(routerName == 'AboutUs' || routerName == 'packageDetails' || routerName == 'detailsMaintenance' ) ? 'collapse navbar-collapse': 'collapse navbar-collapse'" id="navbarNavDropdown">
          <ul class="navbar-nav p-1">
            <li class="nav-item pe-3">
              <router-link :class="(routerName == 'home') ? 'nav-link active': 'nav-link'" aria-current="page"
                to="/"
              >
                {{t('nav.home')}}
              </router-link>
            </li>
    
            <li class="nav-item pe-3 space">
              <router-link to="/aboutus" :class="(routerName == 'AboutUs') ? 'nav-link active': 'nav-link'" >
                <span>{{t('nav.about')}}</span>
              </router-link>
            </li>
    
            <li class="nav-item pe-3">
              <router-link to="/maps" :class="(routerName == 'MapsPage') ? 'nav-link active' : 'nav-link'">
                <span>{{t('nav.map')}}</span>
              </router-link>
            </li>
    
            <li class="nav-item pe-3 space">
              <router-link to="/propertiecreate"
                :class="(routerName == 'propertiecreate') ? 'nav-link active':'nav-link'">
                {{t('nav.realEstateServices')}}
              </router-link>
            </li>
            <!-- <li v-else class="nav-item pe-3">
              <router-link class="nav-link" to="/login">
                {{t('nav.Addadvertisement')}}
              </router-link>
            </li> -->
    
            <li class="nav-item pe-3 space">
              <router-link to="/propertie" 
                :class="(routerName == 'propertie') ? 'nav-link active':'nav-link'">
                {{t('nav.properties')}}
              </router-link>
            </li>
            
    
            <li class="nav-item pe-3 space">
              <router-link to="/maintenance" 
                :class="(routerName == 'MaintenancePage') ? 'nav-link active':'nav-link'">
                {{t('nav.Maintenance')}}
              </router-link>
            </li>
            <li class="nav-item pe-3 space">
              <router-link to="/realEstateBulletin" 
                :class="(routerName == 'realEstateBulletin') ? 'nav-link active':'nav-link'">
                {{$t('realEstateBulletin')}}
              </router-link>
            </li>
            <li class="nav-item mx-2 content-center">
              <button class="btn btn-light btnchangelang" v-if="userLang == 'en'" @click="setLanguage(locale)" >عربي</button>
              <button class="btn btn-light btnchangelang" v-if="userLang == 'ar'" @click="setLanguage(locale)">English</button>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="!GET_USER" class="col d-xs-flex d-sm-none align-items-center text-center">
        <router-link to="/">
          <!-- <img v-if="routerName == 'AboutUs' || routerName == 'packageDetails' || routerName == 'detailsMaintenance'" src="/assets/images/logo-2.png" alt="" class="header-logo" /> -->
          <img :src="(newDesign)? '/assets/images/logo-2.png' : '/assets/images/logo.png'" alt="" class="header-logo" />
        </router-link>
      </div>

      <div class="col col-sm-2">
        <!--begin:Mobile_screen_header -->
        <div class="dropdown main-nav-item">
          <div class="dropdown-toggle profile-button" data-bs-toggle="dropdown" aria-expanded="false" @click="showProfileMenu()">
            <div class="row justify-content-center">
              <div :class="(GET_USER)? 'col-4 col-sm-auto content-center' : 'col-6 col-sm-auto content-center'">
                <div class="avatar-Logo" :style="`background-image: url(${(GET_USER_DATA.avatar)? BASE_URL+'uploads/'+GET_USER_DATA.avatar : '/assets/images/avatar.png'});`"></div>
              </div>
              <div :class="(GET_USER)? 'col-8 col-sm-auto p-0 content-center' : 'col-6 col-sm-auto p-0 content-center'">
                <span v-if="GET_USER">
                  <!-- <img src="/assets/images/icons/Frame-hand.png" alt="">  -->
                  <span class="almarai-bold">
                    {{$t('nav.welcomeBack')}} {{ (GET_USER_DATA.userName)? GET_USER_DATA.userName.trim().split(' ')[0] : '' }} !
                  </span> <br>
                  <span class="sendProfile">{{$t('nav.goto_Profile')}}</span>
                </span>
                <span v-else class="ps-2">{{$t('nav.guest')}}</span>
              </div>
            </div>
          </div>
          <ul id="profileDropdown" :class="(GET_USER)? 'dropdown-menu dropdownList width-UL mouse-hand menu-bar dropdownList-height' : 'dropdown-menu dropdownList width-UL mouse-hand menu-bar'">
            <!-- <li v-if="GET_USER">
              <div class="row">
                <div class="col-12 text-center mb-3">
                  <div class="avatar-img" :style="`background-image: url(${(GET_USER_DATA.avatar)? BASE_URL+'uploads/'+GET_USER_DATA.avatar : '/assets/images/avatar.png'});`">
                  </div>
                </div>
                <div class="col-12 text-center mb-3 fw-bold">{{ GET_USER_DATA.userName }}</div>
                <div v-if="GET_USER_DATA.nafathStatus != 'COMPLETED'" class="col-12 text-center mb-3">
                  <router-link to="/nafath" class="btn btn-warning btn-sm"><i class="fa-solid fa-house-circle-check"></i> {{$t('nafath.linkTitle')}}</router-link>
                </div>
              </div>
            </li> -->
            <li v-if="GET_USER" class="myrequest">
              <div class="row">
                <div class="col-4">
                  <router-link to="/myrequests">
                    <div class="text-center">
                      <!-- <img src="/assets/images/icons/img-2.png" class="max-40" alt=""><br> -->
                      <img src="/assets/images/icons/reserve.png" class="max-20" alt=""><br>
                      <span class="space">{{$t('nav.myRequests')}}</span>
                    </div>
                  </router-link>
                </div>
                <div class="col-4">
                  <router-link to="/wallet">
                    <div class="text-center">
                      <!-- <img src="/assets/images/icons/img-3.png" class="max-40" alt="" /><br> -->
                      <img src="/assets/images/icons/wallet.png" class="max-20" alt="" /><br>
                      <span>{{$t('nav.wallet')}}</span>
                    </div>
                  </router-link>
                </div>
                <div class="col-4">
                  <router-link to="/advertisements">
                    <div class="text-center">
                      <!-- <img src="/assets/images/icons/img-4.png" class="max-40" alt=""><br> -->
                      <img src="/assets/images/icons/save-2.png" class="max-20" alt=""><br>
                      <span class="space">{{$t('nav.myads')}}</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </li>
            <li v-if="!GET_USER" class="dropdown-item">
              <router-link to="/login">
                <i class="fa-solid fa-arrow-right-to-bracket"></i> {{ $t('nav.login') }}
              </router-link>
            </li>
    
            <div class="row pt-2" v-if="GET_USER">
              <div class="col">
                <div class="card profileType">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-auto">
                        <div>{{$t('profile.currentAccount')}}</div>
                        <div class="pt-1">  
                          <img src="/assets/images/icons/profile-circle.png" alt="" class="ms-1 max-20" />
                          <span>{{GET_USER_DATA.accountType == 'personal' ? 'شخصي': GET_USER_DATA.accountType == 'company' ? 'منشأة عقارية' : 'وسيط عقاري'}}</span>
                        </div>
                      </div>
                      <div class="col editAccount">
                        <router-link to="/accountType">
                          <span><img src="/assets/images/icons/edit-2.png" class="max-11" alt=""></span>
                          <span class="me-1">{{$t('profile.changeAccount_Type')}}</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <li v-if="GET_USER" class="dropdown-item p-0"><hr class="dropdown-divider mx-2" /></li>
            
            <!-- <li v-if="GET_USER" class="dropdown-item">
              <h6>{{$t('nav.account')}}</h6>
            </li> -->
            <li v-if="GET_USER" class="dropdown-item">
              <router-link :to="`/portfolio/${GET_USER_DATA.userCode}`">
                <i class="fa-solid fa-circle-user ms-2 profile-icon max-20"></i>
                <span class="mx-2">{{$t('profile.profileMenu')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left "></i>
                <i  v-else class="fa-solid fa-chevron-right "></i>
              </router-link>
            </li>
            <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/profile">
                <img src="/assets/images/icons/profile-circle.png" alt="" class="ms-2 max-20" />
                <span class="mx-2">{{$t('nav.accountDetails')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left "></i>
                <i  v-else class="fa-solid fa-chevron-right "></i>
              </router-link>
            </li>
    
            <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/packagesList">
                <img src="/assets/images/icons/broom.png" alt="" class="ms-2 max-20" />
                <span class="mx-2">{{$t('maintenancePackages')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li>
    
            <!-- <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/packagesList">
                <img src="/assets/images/icons/building-23.png" alt="" class="ms-2 max-20" />
                <span class="mx-2">{{$t('propertyPackages')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li> -->
    
            <!-- <li v-if="GET_USER" class="dropdown-item">
              <img src="/assets/images/icons/money-recive.png" alt="" class="ms-2 max-20" />
              <span class="mx-2">{{$t('realEstate_FinancingRequest')}}</span>
              <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
              <i  v-else class="fa-solid fa-chevron-right"></i>
              <router-link to="/packagesList">
              </router-link>
            </li> -->
    
            <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/previewlist">
                <img src="/assets/images/icons/calendar-edit.png" alt="" class="ms-2 max-20" />
                <span class="mx-2">{{$t('nav.Previews')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right "></i>
              </router-link>
            </li>
    
            <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/propertyrequest">
                <img src="/assets/images/icons/tag-2.png" alt="" class="ms-2 max-20" />
                <span class="mx-2">{{$t('requestProperty')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li>
    
            <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/favorite">
                <img src="/assets/images/icons/heart.png" alt="" class="ms-2 max-20" />
                <span class="mx-2">{{$t('nav.favoriteProperties')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li>
    
            <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/myrents">
                <img src="/assets/images/icons/key.png" alt="" class="ms-2 max-20" />
                <span class="mx-2">{{$t('myrentals')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li>
    
            <li v-if="GET_USER" class="dropdown-item ">
              <router-link to="/myreservations">
                <img src="/assets/images/icons/icon-1.png" alt="" class="ms-2 max-20" />
                <span class="mx-2">{{$t('nav.reservations')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left "></i>
                <i  v-else class="fa-solid fa-chevron-right "></i>
              </router-link>
            </li>
    
            <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/myproperty">
                <img src="/assets/images/icons/myProperty.png" alt="" class="ms-2 max-20" />
                <span class="">{{$t('nav.myProperty')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left "></i>
                <i  v-else class="fa-solid fa-chevron-right "></i>
              </router-link>
            </li>
    
            <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/chats">
                <img src="/assets/images/icons/speech-bubble.png" alt="" class="ms-2 max-20" />
                <span class="mx-2">{{$t('nav.chats')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left "></i>
                <i  v-else class="fa-solid fa-chevron-right "></i>
              </router-link>
            </li>
    
            <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/inviteFriends">
                <!-- <img src="/assets/images/icons/icon-4.png" alt="" class="ms-2 max-40" /> -->
                <i class="fa-solid fa-user-group invite-Icon max-20"></i>
                <span class="mx-2">{{$t('nav.inviteFriends')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li>
            <!-- <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/myrequests">
                <img src="/assets/images/icons/myRequest.png" alt="" class="ms-2 max-40" />
                <span class="mx-2">{{$t('nav.myRequests')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left "></i>
                <i  v-else class="fa-solid fa-chevron-right "></i>
              </router-link>
            </li> -->
            <!-- <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/myrents">
                <img src="/assets/images/icons/myRents.png" alt="" class="ms-2 max-40" />
                <span class="mx-2">{{$t('nav.myRents')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right "></i>
              </router-link>
            </li> -->
            <!-- <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/advertisements">
                <img src="/assets/images/icons/gallery.png" alt="" class="ms-2 max-40" />
                <span class="me-3">{{$t('nav.myads')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li> -->
            <!-- <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/favorite">
                <img src="/assets/images/icons/icon-4.png" alt="" class="ms-2 max-40" />
                <span class="mx-2">{{$t('nav.favoriteProperties')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li> -->
    
            <!-- <li v-if="GET_USER" class="dropdown-item"><hr class="dropdown-divider mx-2" /></li>
            <li v-if="GET_USER" class="dropdown-item">
              <h6>{{$t('nav.Payments')}}</h6>
            </li> -->
            <!-- <li v-if="GET_USER" class="dropdown-item ">
              <router-link to="/wallet">
                <img src="/assets/images/icons/Wallet_1.png" alt="" class="ms-2 max-40" />
                <span class="mx-2">{{$t('nav.wallet')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li> -->
            <!-- <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/financialtransactions">
                <img src="/assets/images/icons/icon-13.png" alt="" class="ms-2 max-40" />
                <span class="">{{$t('nav.financialTransactions')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li> -->
    
            <!-- <li v-if="GET_USER" class="dropdown-item">
              <router-link to="/mybankaccount">
                <img src="/assets/images/icons/bankAccount.png" alt="" class="ms-2 max-40" />
                <span class="mx-2">{{$t('nav.bankAccount')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li> -->
    
            <li class="dropdown-item"><hr class="dropdown-divider mx-2" /></li>
            <li class="dropdown-item">
              <h6>{{$t('nav.More')}}</h6>
            </li>
            <li class="dropdown-item">
              <router-link to="/blog">
                <img src="/assets/images/icons/icon-7.png" alt="" class="ms-2 max-20" />
                <span class="">{{$t('nav.Blog')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li>
            <li class="dropdown-item">
              <router-link to="/questions">
                <img src="/assets/images/icons/icon-9.png" alt="" class="ms-2 max-20" />
                <span class="">{{$t('nav.frequentlyQuestions')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
            </li>
            <li class="dropdown-item">
              <a :href="`https://wa.me/+966920016962?text= ${customer_ServiceMessage}`"  target="_blank">
                <img src="/assets/images/icons/icon-11.png" alt="" class="ms-2 max-20" />
                <span class="">{{$t('nav.Support')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </a>
            </li>
            <li class="dropdown-item ">
              <router-link v-if="!GET_USER" to="/login">
                <img src="/assets/images/customer-service.png" alt="" class="ms-2 max-20" />
                <span class="">{{$t('nav.supportChat')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
              <button v-if="GET_USER" class="nav-btn" data-bs-toggle="modal" data-bs-target="#contactUsChat">
                <img src="/assets/images/customer-service.png" alt="" class="ms-2 max-20" />
                <span class="">{{$t('nav.supportChat')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </button>
            </li>
    
            <li class="dropdown-item ">
              <router-link v-if="!GET_USER" to="/login">
                <img src="/assets/images/icons/participateWin.jpeg" alt="" class="ms-2 max-20" />
                <span>{{$t('participateWin')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
              </router-link>
              <button v-if="GET_USER" class="nav-btn">
                <router-link to="/participateWin">
                <img src="/assets/images/icons/participateWin.jpeg" alt="" class="ms-2 max-20" />
                <span>{{$t('participateWin')}}</span>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                <i  v-else class="fa-solid fa-chevron-right"></i>
                </router-link>
              </button>
            </li>
    
            <li v-if="GET_USER" class="dropdown-item"><hr class="dropdown-divider mx-2" /></li>
            <li v-if="GET_USER" class="dropdown-item" @click.prevent="openPoup">
              <img src="/assets/images/icons/logout.png" alt="" class="ms-2 max-20" />
              <span>{{$t('nav.SignOut')}}</span>
              <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
              <i  v-else class="fa-solid fa-chevron-right"></i>
            </li>
    
            <li class="dropdown-item"><hr class="dropdown-divider mx-2" /></li>
            <li class="myrequest">
              <div class="row">
                <div class="col-4">
                  <!-- Share a message -->
                  <div class="text-center" @click="shareAppFN">
                    <!-- <a href="https://wa.me/?text=https://aqaralmuhaysini.com/ تطبيق عقاري شامل 🏠 بيع وشراء عقار، إدارة الأملاك، صيانة المنازل، مدونات عقارية، وتوثيق العقود." 
                      target="_blank" rel="noopener noreferrer">
                    </a> -->
                    <img src="/assets/images/icons/share.png" class="max-20" alt="" /><br>
                    <span class="pt-2" style="white-space: normal;">{{$t('nav.sharing')}}</span>
                  </div>
                  <!-- WhatsApp Share Button -->
                </div>
                <div class="col-4">
                  <a :href="BASE_URL+'docs/fal.pdf'" target="_blank">
                    <div class="text-center">
                      <img  src="/assets/images/icons/Fal.png" class="max-20" alt="" /><br>
                      <span class="pt-2" style="white-space: normal;">{{$t('nav.val_License')}}</span>
                    </div>
                  </a>
                </div>
                <div class="col-4">
                  <div @click.prevent="TaxـCertificate" class="text-center">
                    <img src="/assets/images/icons/clipboard-text.png" class="max-20" alt="" /><br>
                    <span class="pt-2" style="white-space: normal;">{{$t('nav.taxCertificate')}}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="GET_USER" class="col-3 col-sm-1 d-flex align-items-center justify-content-center">
        <!-- notifications -->
        <div class="dropdown main-nav-item">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" @click="showNotificationMenu()">
            <img v-if="routerName == 'PublicProfile'" 
              src="/assets/images/icons/notification-white.png" class="max-24" alt=""
            >
            <img v-else src="/assets/images/icons/notification-.png" alt="">
          </div>
          <ul id="notificationsDropdown" class="dropdown-menu bs-dropdown-width notifications">
            <h6 class="almarai-bold ms-2">{{$t('nav.notifications')}}</h6>
            <li v-for="(row, index) in rows" :key="index">
              <router-link :to="(row.data && notificationsMap[row.data.section])? (row.data.id)? `/${notificationsMap[row.data.section]}/${row.data.id}` : `/${notificationsMap[row.data.section]}` : '#'">
                <div class="row">
                  <div class="col-auto">
                    <img src="/assets/images/icons/notification-.png" alt="">
                  </div>
                  <div class="col p-0">
                    {{ row.message}}
                  </div>
                </div>
              </router-link>
            </li>
            <li v-if="!rows.length" class="defaultNotification">
              <div class="text-center">
                <img src="/assets/images/icons/notification-.png" alt="">
              </div>
              <p class="pt-2">{{$t('nav.no_Notifications')}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- Button license modal -->
  <button type="button" id="license" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#valـlicenseModal"></button>
  <!-- Modal -->
  <div class="modal fade" id="valـlicenseModal" tabindex="-1" aria-labelledby="valـlicenseModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-lg">
      <div class="modal-content">
        <div class="d-flex p-3">
          <button type="button" class="btn-close pt-3" data-bs-dismiss="modal" aria-label="Close"></button>
          <h1 class="modal-title fs-5 mx-3" id="valـlicenseModalLabel">{{$t('nav.val_License')}}</h1>
        </div>
        <div class="modal-body">
          <div>
            <img :src="BASE_URL+'docs/fal.jpg'" class="w-100" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end:license modal -->
  <!-- Button tax modal -->
  <button type="button" id="tax" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#taxModal"></button>
  <!-- Modal -->
  <div class="modal fade" id="taxModal" tabindex="-1" aria-labelledby="taxModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-lg">
      <div class="modal-content">
        <div class="d-flex p-3">
          <button type="button" class="btn-close pt-3" data-bs-dismiss="modal" aria-label="Close"></button>
          <h1 class="modal-title fs-5 mx-3" id="taxModalLabel">{{$t('nav.taxCertificate')}}</h1>
        </div>
        <div class="modal-body">
          <div>
            <img :src="BASE_URL+'docs/tax1.jpg'" class="w-100 mb-3" alt="">
          </div>
          <div>
            <img :src="BASE_URL+'docs/tax2.jpg'" class="w-100" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end:tax modal -->
  <!-- Modal-begin-signOut -->
  <button type="button" id="openForm" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#signOut">
    Launch demo modal
  </button>
  <!-- Modal -->
  <div class="modal fade d-none" id="signOut" tabindex="-1" aria-labelledby="signOutLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content br-radius-24">
        <!-- <div class="modal-header">
          <h1 class="modal-title fs-5" id="signOutLabel"> {{$t('nav.logOut')}} </h1>
          <button type="button" id="closePoup" class="btn-close ms-0" data-bs-dismiss="modal" aria-label="Close"></button>
        </div> -->
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
        <div class="modal-body">
          <button type="button" id="closePoup" class="btn-close d-none ms-0" data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="row justify-content-center">
            <div class="col text-center">
              <img src="/assets/images/icons/logout_Logo.png" class="width-80" alt="">
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col text-center">
              <h5 class="almarai-bold">{{$t('nav.oneStep')}} <br>{{$t('nav.twoStep')}}</h5>
              <h6 class="gray-color fonttext-14">{{$t('nav.someTimes')}}</h6>
            </div>
          </div>
          <div class="row justify-content-center pt-2">
            <div class="col-11 text-center" @click="closeModal">
              <div class="btn-green">{{$t('nav.buttonContinue')}}</div>
            </div>
            <div v-if="isLoading" class="text-center"> 
              <loader/> 
            </div>
            <div v-else class="col-11 text-center my-2 mouse-hand" @click.prevent="removeLogin()">
              <div>{{$t('nav.buttonExit')}}</div>
            </div>
          </div>
        </div>
        <!-- <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button>
        </div> -->
      </div>
    </div>
  </div>
  <!-- Modal-end-signOut -->

  <!-- Button chat modal -->
  <div class="modal fade" id="contactUsChat" tabindex="-1" aria-labelledby="contactUsChatLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-6" id="contactUsChatLabel">{{$t('nav.supportChat')}}</h1>
          <button type="button" id="chatCloseBtn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form action="" @submit.prevent="startChat">
            <div v-if="chatError" class="row">
              <div class="col mb-3">
                <div class="alert alert-danger">{{ errorMsg }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col mb-3">
                <input type="text" v-model="chatTitle" class="form-control" :placeholder="$t('nav.chatTitle')">
              </div>
            </div>
            <div class="row">
              <div class="col text-start">
                <input type="submit" class="btn btn-warning" :value="$t('nav.chatSend')">
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- end:chat modal -->

  <!-- begin:Popup share_Apps -->
    <button type="button" id="shareApp" class="btn btn-primary d-none" data-bs-toggle="modal"
      data-bs-target="#sharePopup"
    >
    </button>
    <div class="modal fade d-none" id="sharePopup" tabindex="-1" aria-labelledby="shareAppLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body text-center">
            <div class="text-center">
              <img src="/assets/images/icons/shareApps.png" class="width-80" alt="" />
            </div>
            <p class="title_ShareApp">{{$t("shareApps")}}</p>
            <div class="fontGray-73">{{$t('share_Amazing')}}</div>
            <!-- <div class="gray-color" v-if="affiliatePrice">
              {{$t("inviteFriends_register")}}
              {{affiliatePrice}}
              <span>{{$t('riyals_Yourwallet')}}</span>
            </div> -->
            <div class="row pt-3 justify-content-center">
              <div class="col-11 col-md-8 btn-green almarai-bold" v-if="GET_USER">
                <a :href="'https://wa.me/?text=حبيت أشاركك تطبيق عقاري أعجبني ' + ' https://applink.one/link/2LOXxL ' + 'خدمات عقارية متنوعة في مكان واحد، من البحث عن العقار إلى إدارة الأملاك والصيانة' + 'إذا جربته علمني، وش أكثر شيء شد انتباهك؟  ' + 'الرمز الترويجي لدعوة صديق'+ GET_USER_DATA.userCode" class="text-white"
                  target="_blank">
                  {{ $t("button_ShareNow") }}
                </a>
              </div>
              <div v-else class="col-12 col-md-8 btn-green almarai-bold" @click="loaginFN">
                {{ $t("button_ShareNow") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:Popup Share Apps affiliatePrice -->

    <!--begin:modal login-->
    <div class="modal bg-modal" dir="rtl" tabindex="-1" id="formShareLogin">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-auto mouse-hand" @click.prevent="closePopupshare">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="loginTitle">
                  {{$t("formLogin.title_1")}}
                </div>
                <p class="fontGray-73 mb-1 pt-1">
                  {{$t("formLogin.title_2")}} <br />
                  {{$t("formLogin.title_3")}}
                </p>
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 col-md-8 mb-2" @click="sendLogin">
                <div class="form-control btn-green">
                  {{$t("formLogin.title_4")}}
                </div>
              </div>
              <div class="col-12 col-md-8 pt-1" @click="sendRegister">
                <router-link to="/register">
                  <div class="form-control btn-black">
                    {{ $t("formLogin.title_5") }}
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Login-->
</template>

<script setup> 
  import { useI18n } from 'vue-i18n'
  const { t, locale, availableLocales } = useI18n({ useScope: 'global' });
</script>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';
const navLinks = document.querySelectorAll('.nav-item');

navLinks.forEach(link => {
  link.addEventListener('click', function () {
    // Remove 'active' class from all links
    navLinks.forEach(item => item.classList.remove('active'));
    
    // Add 'active' class to the clicked link
    this.classList.add('active');
  });
});
export default {
  name: "NavBarItems",
  props: {
    newDesign: {
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
      routerName: "home",
      rows: [],
      isLoading: false,
      userLang: "ar",
      hasError: false,
      message: "",
      errorNumber: null,
      notificationsMap: {
        property: 'propertydetails',
        preview: 'previewdetails',
        reservation: 'propReservationDetails',
        manage_property_services: 'myrequests?dataType=propertyManagement',
        property_documented: 'myrequests',
        orders: 'maintenancedetails',
        photos: 'photographyDetails',
        finance: 'myrequests',
        lawyer_requests: 'lawyerRequestedDetails',
        exchange: 'businessTransfer',
        ownedProperty: 'rental'
      },
      chatTitle: '',
      errorMsg: '',
      chatError: false,
      customer_ServiceMessage: this.$t('customer_ServiceMessage'),
    }
  },

  computed: {
    ...mapGetters(["GET_USER", "GET_USER_DATA", "ISLOADING","GET_ROUTE",'BASE_URL', 'CHAT_CLIENT']),
  },

  methods: {
    removeLogin() {
      this.hasError = false;
      this.isLoading = true;
      this.$http.get("/api/users/logout").then((res) => {
        // console.log(res);
        this.$store.commit("REMOVE_USER_DATA");
        window.location.href = "/login";
        this.isLoading = false;
      }).catch((err) => {
        // console.log();
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    notificationsList(){
      if(this.ISLOADING){
        setTimeout(() => this.notificationsList(), 200);
      }else{
        if(this.GET_USER){
          this.$http.get("/api/users/notifications").then(res => {
            // console.log(res);
            const notificationArray = [];
            for(let i=0; i< res.data.rows.length; i++){
              if(res.data.rows[i].data){
                if(res.data.rows[i].data.section == 'manage_property_services'){
                  res.data.rows[i].data.id = null;
                  notificationArray.push(res.data.rows[i]);
                }
                if(res.data.rows[i].data.section == 'property'){
                  res.data.rows[i].data.id = res.data.rows[i].data.id + '?a=1';
                  notificationArray.push(res.data.rows[i]);
                }
              }else {
                notificationArray.push(res.data.rows[i]);
              }
            }
            this.rows = res.data.rows;
          }).catch(() => {
            // console.log(err);
          });
        }
      }
    },
    valـlicense(){
      document.getElementById('license').click();
    },
    TaxـCertificate(){
      document.getElementById('tax').click();
    },

    setLanguage(currentlang){
      let newlang = 'ar';
      if(currentlang == "ar"){
        newlang = 'en';
      }
      currentlang = newlang;
      localStorage.setItem('lang', newlang);
      window.location.reload();
    },
    moment,
    formatDate(){
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime);
    },

    openPoup(){
      document.getElementById('openForm').click();
      // const modal = bootstrap.Modal.getInstance(
      //   document.getElementById('signOut')
      // );
      // modal.hide();
    },

    closeModal(){
      document.getElementById('closePoup').click();
    },

    menuLinkAddClick(){
      document.querySelectorAll('#navbarNavDropdown .nav-link').forEach(link => {
        link.addEventListener('click', (e) => {
          document.getElementById('mobNavBtn').click();
          // const navBtn = document.getElementById('mobNavBtn');
          // const navDiv = document.getElementById('navbarNavDropdown');
          // if(navBtn){
          //   navBtn.setAttribute('aria-expanded', 'false');
          // }
          // if(navDiv){
          //   navDiv.classList.remove('show');
          // }
        });
      });
    },
    menuLinkRemoveClick(){
      document.querySelectorAll('#navbarNavDropdown .nav-link').forEach(link => {
        link.removeEventListener('click', (e) => {});
      });
    },
    menuClick(){
      const navBtn = document.getElementById('mobNavBtn');
      if(navBtn){
        const btnOpen = navBtn.getAttribute('aria-expanded');
        const items = document.getElementsByClassName('main-nav-item');
        for (const el of items) {
          if(btnOpen == 'true'){
            // el.classList.add('d-none');
            this.menuLinkAddClick();
          }else{
            // el.classList.remove('d-none');
            this.menuLinkRemoveClick();
          }
        }
      }
    },
    showProfileMenu(){
      const navBtn = document.getElementById('mobNavBtn');
      const menu1 = document.getElementById('navbarNavDropdown');
      const menu2 = document.getElementById('notificationsDropdown');
      if(navBtn)
        navBtn.setAttribute('aria-expanded', 'false');
      if(menu1)
        menu1.classList.remove('show');
      if(menu2)
        menu2.classList.remove('show');
    },
    showNotificationMenu(){
      const navBtn = document.getElementById('mobNavBtn');
      const menu1 = document.getElementById('navbarNavDropdown');
      const menu2 = document.getElementById('profileDropdown');
      if(navBtn)
        navBtn.setAttribute('aria-expanded', 'false');
      if(menu1)
        menu1.classList.remove('show');
      if(menu2)
        menu2.classList.remove('show');
    },
    startChat(){
      this.chatError = false;
      if(!this.chatTitle || this.chatTitle.trim().length < 5){
        this.errorMsg = this.$t('nav.chantTitleRequired');
        this.chatError = true;
        return;
      }

      this.$http.post('/api/chats/createContactChannel', {
        title: this.chatTitle,
      }).then(({data}) => {
        const filter = {type: "messaging", cid: {$eq: `messaging:${data.channelId}`}};
        const sort = [{ last_message_at: -1 }];
        const options = {
          limit: 1, //watch: true,
        };
        this.CHAT_CLIENT.queryChannels(filter, sort, options).then(channel => {
          channel[0].sendMessage({
            text: this.chatTitle,
          }).then(() => {
            const closeBtn = document.getElementById('chatCloseBtn');
            if(closeBtn)
              closeBtn.click();
            this.$router.push({path : '/chats', query: { id: data.channelId }});
          }).catch(err => {
            this.errorMsg = this.$t('nav.chatCantSend');
            this.chatError = true;
          });
        }).catch(err => {
          this.errorMsg = this.$t('nav.chatCantSend');
          this.chatError = true;
        });
      }).catch(err => {
        this.errorMsg = this.$t('nav.chatCantSend');
        this.chatError = true;
      });
    },

    loaginFN(){
      document.getElementById('shareApp').click();
      document.getElementById("formShareLogin").style.display = "block";
    },

    closePopupshare(){
      document.getElementById("formShareLogin").style.display = "none";
    },

    shareAppFN(){
      document.getElementById('shareApp').click();
    },

    sendLogin(){
      document.getElementById("formShareLogin").style.display = "none";
      this.$router.push({path: '/login'});
    },

    sendRegister(){
      document.getElementById("formShareLogin").style.display = "none";
      this.$router.push({path: '/register'});
    }

  },
  created(){
    this.notificationsList();
    this.userLang = localStorage.getItem('lang') ??  'ar';
  },

  watch: {
    $route(to, from) {
      // console.log('Route changed from', from.name, 'to', to.name)
      this.routerName = to.name;
      // console.log(this.routerName);
    },
  },

};
</script>
<style scoped>
  .nav-btn {
    background: none;
    border: none;
    width: 100%;
    padding: 0;
    text-align: start;
  }
  .modal-header .btn-close {
    margin-left: 0;
  }
  .myrequest .dropdown-item:hover {
    /* background-color: var(--bs-dropdown-link-hover-bg); */
    background-color: #fff !important;
  }
  li.dropdown-item {
    line-height: 30px;
    vertical-align: middle;
  }
  .profile-icon {
    color: #AA9359;
    font-size: 19px;
    vertical-align: middle;
  }
</style>
